module.exports = __webpack_public_path__ + "img/logo-b-horizontal.7feaa938.png";